export default {
	links: {
		companyInformation: 'Company information',
	},
	titles: {
		accountSettings: 'Account',
	},
};
